import { FieldMapShape } from './field-map-shape';
import * as L from 'leaflet';
import { FieldMapContext } from '../field-map-context.model';

import { Block } from './block';

export class Field extends FieldMapShape {

    id = '';
    isEditing = false;
    isSelected = false;
    name = '';
    polygon: L.Polygon | null = null;
    editInitialLatLng?: L.LatLng[][];
    blocks: Block[] = [];
    blocksDrawingLayer: L.FeatureGroup | null = null;
    type: 'FIELD' = 'FIELD';
    isOutsideBoundary?: boolean;
    drawingFeatureGroup: L.FeatureGroup;

    constructor(params: {
        map: L.Map,
        id: string,
        name: string,
        polygon: L.Polygon,
        fieldsDrawingLayer: L.FeatureGroup,
        fieldMapContext: FieldMapContext
    }) {
        super(params.map);
        this.id = params.id;
        this.name = params.name;
        this.polygon = params.polygon;
        this.drawingFeatureGroup = params.fieldsDrawingLayer;
        this.fieldMapContext = params.fieldMapContext;
        this.initialize();
    }

    initialize() {
        this.blocksDrawingLayer = L.featureGroup().addTo(this.map);
        this.fieldMapContext.fieldsMap.set(this.id, this);
        super.initialize();
    }

    draw(): void {
        this.drawingFeatureGroup.addLayer(this.polygon);
        super.draw();
    }

    delete(): void {

        this.fieldMapContext.beforeDelete(this).then(() => {
            this.reset();

            // Remove the field from the fieldMapContext's fields array
            this.fieldMapContext.fieldsMap.delete(this.id);

            // Remove the field's polygon from the drawingFeatureGroup
            if (this.drawingFeatureGroup && this.polygon) {
                this.drawingFeatureGroup.removeLayer(this.polygon);
            }

            // Delete all blocks associated with this field
            this.blocks.forEach((block) => {
                block.delete();
            });

            // Clear the blocks array
            this.blocks = [];

            // Remove the blocksDrawingLayer from the map
            if (this.blocksDrawingLayer) {
                this.blocksDrawingLayer.remove();
            }

            // Remove any editing layers if they exist
            if (this.editInitialLatLng) {
                this.editInitialLatLng = undefined;
            }

            // Remove event listeners
            this.removeListeners();

            // Clear references
            this.polygon = null;
            this.map = null;
            this.fieldMapContext = null;
            this.drawingFeatureGroup = null;
            this.blocksDrawingLayer = null;

            // Reset other properties
            this.isEditing = false;
            this.isSelected = false;
            this.isOutsideBoundary = undefined;
        }, (error) => {
        });

    }

    isEditable(): boolean {
        return this.blocks.length === 0;
    }

    isResizable(): boolean {
        return this.blocks.length === 0;
    }

    isRotatable(): boolean {
        return this.blocks.length === 0;
    }

    isSaveable(): boolean {
        return this.isEditing && this.blocks.length === 0;
    }

    isDeletable(): boolean {
        return this.blocks.length === 0;
    }

}
